var _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgForAutomaker = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 153,
  height: 17
}, props), _text || (_text = /*#__PURE__*/React.createElement("text", {
  fill: "#FFF",
  fillRule: "evenodd",
  fontFamily: "SukhumvitSet-Medium, Sukhumvit Set",
  fontSize: 20,
  fontWeight: 400,
  letterSpacing: 0.667,
  transform: "translate(-356 -26)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 355,
  y: 40
}, "( for automaker )"))));
export { SvgForAutomaker as ReactComponent };
export default __webpack_public_path__ + "images/for-automaker.67856b6f.svg";